import styled from 'styled-components';

export const StyledUserPanelSubjectElement = styled.form`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
